import { render, staticRenderFns } from "./GeoVehiclesTable.vue?vue&type=template&id=51c7654d&"
import script from "./GeoVehiclesTable.vue?vue&type=script&lang=js&"
export * from "./GeoVehiclesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VSnackbar,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c7654d')) {
      api.createRecord('51c7654d', component.options)
    } else {
      api.reload('51c7654d', component.options)
    }
    module.hot.accept("./GeoVehiclesTable.vue?vue&type=template&id=51c7654d&", function () {
      api.rerender('51c7654d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dispatching/GeoVehiclesTable.vue"
export default component.exports